import { Controller } from "@hotwired/stimulus"
import { reactor } from "../lib/reactor"

const DESKTOP = "(min-width: 1024px)"

export default class extends Controller {
  connect() {
    reactor(this)
    this.sync = this.sync.bind(this)
    this.onFocusOut = this.onFocusOut.bind(this)
    this.media = window.matchMedia(DESKTOP)
    this.group = this.element.closest(".group\\/sidebar")
    this.element.addEventListener("focus", this.sync)
    this.element.addEventListener("blur", this.sync)
    this.media.addEventListener("change", this.sync)
    window.addEventListener("resize", this.sync)
    this.group?.addEventListener("focusin", this.sync)
    this.group?.addEventListener("focusout", this.onFocusOut)
    this.sync()
  }

  disconnect() {
    this.element.removeEventListener("focus", this.sync)
    this.element.removeEventListener("blur", this.sync)
    this.media.removeEventListener("change", this.sync)
    window.removeEventListener("resize", this.sync)
    this.group?.removeEventListener("focusin", this.sync)
    this.group?.removeEventListener("focusout", this.onFocusOut)
  }

  toggle(event) {
    event.preventDefault() // Safari/FF skip button tap-focus. mousedown + this, then focus/blur ourselves
    if (this.open) {
      this.blurGroup()
    } else if (this.sidebar) {
      this.sidebar.toggleAttribute("inert", false)
      this.sidebar.focus({preventScroll: true})
    } else {
      this.element.focus()
    }
  }

  morph() {
    this.sync()
  }

  onFocusOut() {
    requestAnimationFrame(this.sync)
  }

  sync() {
    const desktop = this.media.matches
    const open = this.open
    this.element.setAttribute("aria-expanded", (!desktop && open) ? "true" : "false")
    const sidebar = this.sidebar
    if (!sidebar) return
    sidebar.toggleAttribute("inert", !(desktop || open))
  }

  blurGroup() {
    const active = document.activeElement
    if (active instanceof HTMLElement && this.group?.contains(active)) active.blur()
  }

  get open() {
    return Boolean(this.group?.contains(document.activeElement))
  }

  get sidebar() {
    const id = this.element.getAttribute("aria-controls")
    return id ? document.getElementById(id) : null
  }
}
